/*
 * @Description:
 * @Date: 2021-06-26 17:41:31
 */

export const auditStatusMapping = {
  0: '未审核',
  1: '审核中',
  2: '审核通过',
  3: '审核未通过'
};
